module.exports = __webpack_public_path__ + "img/automate-lab.b30d2134.svg";